var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("avatar avatar--size-" + _vm.size)},[(_vm.image)?_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.image,"alt":"avatar"}}):_c('span',{staticClass:"avatar__placeholder",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }